/***************************************** INITIAL STATE ********************************************/
export const INITIAL_STATE = {
    isServerOnMaintenance: false,
}

/***************************************** ACTION TYPES *********************************************/
const reducerName = 'GLOBAL_'
const actionTypes = {
    SET_IS_SERVER_ON_MAINTENANCE: `${reducerName}SET_IS_SERVER_ON_MAINTENANCE`,
}

/******************************************** ACTIONS ***********************************************/
export const actions = {
    setIsServerOnMaintenance: values => {
        return {
            type: actionTypes.SET_IS_SERVER_ON_MAINTENANCE,
            payload: { values },
        }
    },
}

/******************************************* REDUCER ************************************************/
const globalReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SET_IS_SERVER_ON_MAINTENANCE:
            return {
                ...state,
                isServerOnMaintenance: action.payload.values,
            }

        default:
            return state
    }
}

export default globalReducer
